module.exports = __webpack_public_path__ + "img/1Ri2L5PU8Orc6bI4P9YA7bHxcZTbmCMb7.e6471f8b.png";